module.exports = __webpack_public_path__ + "img/facebook_sample_icon.db0a455c.svg";